import { ImageInstanceCollection, Project } from '@/api';

export function getDefaultContentState() {
  return {
    representatives: [],
    onlines: [],
    contentLoading: false,
    images: [],
    imageGroups: [],
    activeImageGroupForViewer: null,
    currentPage: 1,
    perPage: 15,
    totalImages: 0,
  };
}

export const contentMutations = {
  SET_PROJECT_DETAILS(state, { representatives, onlines }) {
    state.representatives = representatives;
    state.onlines = onlines;
  },
  SET_CONTENT_LOADING(state, loading) {
    state.contentLoading = loading;
  },
  SET_CONTENT_DATA(state, { images, imageGroups }) {
    state.images = images;
    state.imageGroups = imageGroups;
  },
  SET_ACTIVE_IMAGE_GROUP_FOR_VIEWER(state, groupId) {
    state.activeImageGroupForViewer = groupId;
  },
  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
  SET_PER_PAGE(state, perPage) {
    state.perPage = perPage;
  },
  SET_TOTAL_IMAGES(state, total) {
    state.totalImages = total;
  },
};

export const contentActions = {
  async fetchContent({ state, commit }) {
    commit('SET_CONTENT_LOADING', true);

    try {
      let images = [];
      let imageGroups = [];
      let totalImagesCount = 0;

      if (!state.selectedItem) {
        commit('SET_CONTENT_DATA', { images: [], imageGroups: [] });
        commit('SET_TOTAL_IMAGES', 0);
        return;
      }

      const collectionParams = {
        nbPerPage: state.perPage
      };

      if (state.selectedItemType === 'project') {
        imageGroups = state.selectedItem.imageGroups || [];

        const imageInstanceCollection = new ImageInstanceCollection({
          ...collectionParams,
          filterKey: 'project',
          filterValue: state.selectedItem.id
        });

        await imageInstanceCollection.fetchPage(state.currentPage - 1);
        const fetchedImages = imageInstanceCollection.array;
        images = fetchedImages.filter(image => !image.imageGroup);
        totalImagesCount = imageInstanceCollection.totalNbItems;
      } else if (state.selectedItemType === 'imageGroup') {
        const imageInstanceCollection = new ImageInstanceCollection({
          ...collectionParams,
          filterKey: 'imagegroup',
          filterValue: state.selectedItem.id
        });

        await imageInstanceCollection.fetchPage(state.currentPage - 1);
        images = imageInstanceCollection.array;
        totalImagesCount = imageInstanceCollection.totalNbItems;
      }

      commit('SET_CONTENT_DATA', { images, imageGroups });
      commit('SET_TOTAL_IMAGES', totalImagesCount);
    } catch (error) {
      console.error('Error fetching content:', error);
      commit('SET_CONTENT_DATA', { images: [], imageGroups: [] });
      commit('SET_TOTAL_IMAGES', 0);
    } finally {
      commit('SET_CONTENT_LOADING', false);
    }
  },

  async fetchProjectDetails({ state, commit }) {
    if (state.selectedItemType !== 'project' || !state.selectedItem) {
      return;
    }

    try {
      const projectModel = new Project(state.selectedItem);
      const representatives = (await projectModel.fetchRepresentatives()).array;
      commit('SET_PROJECT_DETAILS', { representatives, onlines: [] });
    } catch (error) {
      console.error('Error fetching project details:', error);
      commit('SET_PROJECT_DETAILS', { representatives: [], onlines: [] });
    }
  },

  setActiveImageGroupForViewer({ commit }, groupId) {
    commit('SET_ACTIVE_IMAGE_GROUP_FOR_VIEWER', groupId);
  },

  setPage({ commit, dispatch }, page) {
    commit('SET_CURRENT_PAGE', page);
    return dispatch('fetchContent');
  },

  setPerPage({ commit, dispatch }, perPage) {
    commit('SET_PER_PAGE', perPage);
    commit('SET_CURRENT_PAGE', 1);
    return dispatch('fetchContent');
  },
};

export const contentGetters = {
  contentLoading: state => state.contentLoading,
  contentImages: state => state.images,
  contentImageGroups: state => state.imageGroups,
  currentPage: state => state.currentPage,
  perPage: state => state.perPage,
  totalImages: state => state.totalImages,
};
